import axios from "axios"
const BASE_URL = process.env.REACT_APP_API_URL


class S3UploadApi {
    uploadImage(file) {
        return axios.post(`${BASE_URL}/cms/s3Bucket/imageUpload`, file)
    }
    deleteImage(data) {
        return axios.post(`${BASE_URL}/cms/s3Bucket/deleteS3`, data)
    }
   
}

export default new S3UploadApi()
